
























































import BaseComponent from "@/components/base/BaseComponent";
import LoansDetails
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/LoansDetails.vue";
import MoneyWithdrawalDetails
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/MoneyWithdrawalDetails.vue";
import {v4 as uuidv4} from "uuid";
import {Component} from 'vue-property-decorator';

@Component({
  components: {MoneyWithdrawalDetails, LoansDetails}
})
export default class MoneyWithdrawalEducationFund extends BaseComponent {
  private uniqueId = uuidv4();
  private radioSelection: number | null = 0

  private moneyWithdrawalEducationFundRequest: any = {}


  mounted() {
    this.moneyWithdrawalEducationFundRequest = {
      ...this.moneyWithdrawalEducationFundRequest,
      withdrawalDetailsCode: 0,
      loanDetailsCode: 0
    }

    this.$emit('updateChanges', this.moneyWithdrawalEducationFundRequest)
  }

  private onRadioChange(value: number): void {
    this.moneyWithdrawalEducationFundRequest = {
      ...this.moneyWithdrawalEducationFundRequest,
      withdrawalDetailsCode: value
    }

    this.$emit('updateChanges', this.moneyWithdrawalEducationFundRequest)
  }

  clearIllegalWithdrawalRadioChoice() {
    this.radioSelection = null;
  }


  handleLoanSelectionChanged(loanSelection: number) {
    this.moneyWithdrawalEducationFundRequest = {
      ...this.moneyWithdrawalEducationFundRequest,
      loanDetailsCode: loanSelection
    }

    this.$emit('updateChanges', this.moneyWithdrawalEducationFundRequest)
  }

  handleWithdrawalDetailsChange(withdrawalType: number, moneyAmount: number) {
    this.moneyWithdrawalEducationFundRequest = {
      ...this.moneyWithdrawalEducationFundRequest,
      partialWithdrawalAmount: moneyAmount,
      isFullWithdrawal: withdrawalType === 0
    }

    this.$emit('updateChanges', this.moneyWithdrawalEducationFundRequest)
  }
}
